import { env } from 'constants';
import CustomRoute from 'CustomRoute';
import Login from 'pages/Authentication/Login';
import Otp from 'pages/Authentication/OTP';
import Signup from 'pages/Authentication/SignUp';
import InternalServerErrorPage from 'pages/InternalServerErrorPage';
import Merchant from 'pages/Merchant';
import MerchantsMap from 'pages/MerchantsMap';
import NotFoundPage from 'pages/NotFound';
import React, { lazy, useMemo } from 'react';
import { Switch } from 'react-router-dom';
import GfoEntry from '../pages/GfoEntry';

const GENERAL_ROUTES = [
  { path: '/login', component: Login },
  { path: '/signup', component: Signup },
  { path: '/otp', component: Otp },
  { path: '/profile', component: lazy(() => import('pages/Profile')) },
  { path: '/order/*', component: lazy(() => import('pages/Order')), exact: true },
  { path: '/500', component: InternalServerErrorPage },
];

const WL_CATERING_ROUTES = [
  ...GENERAL_ROUTES,
  { path: '/', component: Merchant },
];
const MP_CATERING_ROUTES = [
  ...GENERAL_ROUTES,
  { path: '/', component: MerchantsMap, exact: true },
  { path: '/gfo/:id/:token', component: GfoEntry },
  { path: '/place/:merchantId', component: Merchant },
  { path: '/merchants/:query?', component: lazy(() => import('pages/Merchants')) },
  { path: '/search/:query?', component: lazy(() => import('pages/Merchants')) },
];

function Routes({ children }) {

  const routes = useMemo(() => {
    if (env.IS_MARKETPLACE) {
      return MP_CATERING_ROUTES;
    }
    return WL_CATERING_ROUTES;
  }, []);

  const routesToRender = [
    ...routes,
    { path: '*', component: NotFoundPage },
  ];

  return (
    <Switch>
      {routesToRender.map(({ component: Component, ...rest }) => (
        <CustomRoute key={rest.path} {...rest} component={Component} />
      ))}
    </Switch>
  );
}

export default Routes;
